module.exports = __webpack_public_path__ + "img/t1-15.644d0a21.png";